import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../hooks";
import AuthModals from "../components/auth/AuthModals";
import { useLayout } from "../context";

const PrivateRoute = () => {
  let navigate = useNavigate();

  const { isLoggedIn, isGuest } = useAuth();
  const { activeModal, setActiveModal } = useLayout();

  useEffect(() => {
    if ((!isLoggedIn || isGuest) && activeModal !== "login") {
      setActiveModal("login");
    }
  }, [isLoggedIn, isGuest]);

  if (isLoggedIn && !isGuest) {
    return <Outlet />;
  }

  return (
    <AuthModals
      activeModal={activeModal}
      onChange={(option) => setActiveModal(option)}
      onClose={() => {
        setActiveModal(null);
        navigate("/");
      }}
      onSuccess={() => setActiveModal(null)}
      allowGuest={false}
    />
  );
};

export default PrivateRoute;
